import { render } from "./ProfileForm.vue?vue&type=template&id=57582a0a"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"
script.render = render

export default script